export const LOCAL = 'local';
export const PREPROD = 'preprod';
export const PRODUCTION = 'production';
